import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import history from "../../history";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CardBody,
  Card,
  Form,
} from "reactstrap";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/fa/close";
import DesignCard from "../DesignCard";
import CustomButton from "../CustomButton";
import InputText from "../InputText";
import { fetchQueryParams } from "../../utils/comman";
import Loader from "../Loader";
import {
  helperFunctionForDate,
  helperFunctionForTime,
  helperFunctionForStatus,
  spaceValidation,
  specialCharacters,
} from "../../utils/helperFunction";
import UploadFile from "../UploadFile";
import { toast } from "react-toastify";

import get from "lodash/get";

const _ = { get };

const initialState = {
  formId: "",
  status: "",
  rejectionReason: "",
  toggleRejectModal: false,
  images: [
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
    {
      image: null,
      preview: null,
    },
  ],
  hashtagText: "",
  hashtags: [],
  description: "",
};

function rideDetail(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);
  const [modal, setModal] = useState(false);

  const toggle = () => {
    state.hashtags = [];
    state.images = [
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
      {
        image: null,
        preview: null,
      },
    ];
    state.description = "";
    state.hashtagText = "";
    setState({ ...state });
    setModal(!modal);
  };

  useEffect(() => {
    let queryParams = props.query;
    if (props.selectedId) {
      props.handleFetchSingleRide(props.selectedId);
    }
  }, [props.selectedId]);

  const handleGoBack = () => {
    props.handleToggleModel();
  };

  console.log("page", props.page);

  const handleGoBackFromModeration = () => {
    props.handleToggleModel();
  };

  const handleToUpdate = () => {
    const params = fetchQueryParams(props.query);
    history.push(`/rides/update?id=${props.selectedId}`);
  };

  const handleRideUpdate = () => {
    const params = fetchQueryParams(props.query);
    history.push(
      `/rides/ride-update?id=${props.selectedId}&status=${props.status}`
    );
  };

  const handleNameChange = (e) => {
    state[e.target.name] = e.target.value;
    setState({ ...state });
  };

  const handleToggleRejectModal = () => {
    const newState = { ...state };
    newState.toggleRejectModal = false;
    setState(newState);
  };

  const handleChangeHashtag = (e) => {
    let value = e.target.value;
    if (value.match(spaceValidation) && !value.match(specialCharacters)) {
      state[e.target.name] = e.target.value;
      setState({ ...state });
    }
  };

  const handleAddHashTag = () => {
    if (state.hashtagText) {
      state.hashtags.push(`#${state.hashtagText}`);
      state.hashtagText = "";
      setState({ ...state });
    }
  };

  const handleRemoveHasTag = (e, index) => {
    if (index > -1) {
      state.hashtags.splice(index, 1);
    }
    setState({ ...state });
  };

  const handleStatusSubmit = (e, status) => {
    e.preventDefault();
    if (status === "REJECTED") {
      state.status = "REJECTED";
      state.toggleRejectModal = true;
      setState({ ...state });
    } else if (status === "APPROVED") {
      state.status = "APPROVED";
      setState({ ...state });
      let data = {
        rideId: props.selectedId,
        status: status,
        rejectionReason: "",
        currentStatus: props.status,
      };
      props.handleRideModeration(data, props.status);
      props.handleToggleModel();
    }
  };

  const handleSubmitRejection = (e) => {
    e.preventDefault();
    let data = {
      rideId: props.selectedId,
      status: state.status,
      rejectionReason: state.rejectionReason,
      currentStatus: props.status,
    };
    state.toggleRejectModal = false;
    setState({ ...state });
    props.handleRideModeration(data, props.status);
    props.handleToggleModel();
  };

  const handleImageChange = (e, idx) => {
    e.preventDefault();
    var fileTypes = ["jpg", "jpeg", "png"];
    if (e.target.files[0]) {
      var extension = e.target.files[0].name
          .split(".")
          .pop()
          .toLowerCase(), //file extension from input file
        isSuccess = fileTypes.indexOf(extension) > -1;

      if (isSuccess) {
        let reader = new FileReader();
        let file = e.target.files[0];

        reader.onloadend = () => {
          saveImage(reader.result, file, idx);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(
          _.get(
            elements,
            "branchCreationElement.imageValidationElement",
            "only '.jpg' , '.jpeg' , '.png' file types are accepted"
          )
        );
      }
    } else {
    }

    e.target.value = "";
  };
  const deleteImage = (idx) => {
    const newState = { ...state };
    const images = state.images.map((image) => ({ ...image }));
    newState.images = images;

    newState.images[idx].preview = null;
    newState.images[idx].image = null;

    setState(newState);
  };

  const saveImage = (preview, image, idx) => {
    const newState = { ...state };
    const images = state.images.map((image) => ({ ...image }));
    newState.images = images;

    newState.images[idx].preview = preview;
    newState.images[idx].image = image;

    setState(newState);
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let queryParams = props.query;
    const params = fetchQueryParams(queryParams);
    const formData = new FormData();

    const images = state.images.map((image) => {
      return image.image;
    });

    for (let image of images) {
      formData.append("images", image);
    }
    formData.append("activityId", props.selectedId);
    formData.append("category", "ride");
    formData.append("description", state.description);
    formData.append("hashtag", JSON.stringify(state.hashtags));

    if (images[0] || images[1] || images[2] || images[3] || images[4]) {
      props.handleRideGallery(formData);
      setModal(!modal);
    } else {
      toast.error(
        _.get(
          elements,
          "branchCreationElement.imageValidationElem",
          "Upload Image"
        )
      );
    }
  };

  useEffect(() => {
    const newState = { ...state };
    state.rejectionReason = "";
    state.toggleRejectModal = false;
    setState(newState);
  }, []);

  return (
    <React.Fragment>
      <div className="hideSearch">
        {props.singleRideStatus && <Loader />}
        {props.moderateRideGalleyStatus && <Loader />}
        <Form>
          <Modal
            backdrop={true}
            centered={true}
            isOpen={modal}
            toggle={toggle}
            size={"xl"}
          >
            <ModalHeader toggle={toggle}>
              {_.get(
                elements,
                "branchCreationElement.galleryHeadingElement",
                "Gallery"
              )}
            </ModalHeader>
            <ModalBody>
              <div className="d-flex flex-row light_Scroll px-3">
                {state.images.length &&
                  state.images.map((image, idx) => {
                    return (
                      <UploadFile
                        key={`image${idx}`}
                        id={`image${idx}`}
                        image={image}
                        handleImageChange={(e) => handleImageChange(e, idx)}
                        deleteImage={() => deleteImage(idx)}
                      />
                    );
                  })}
              </div>

              <Row className="mt-3 pt-3">
                <Col xl={6} sm={12} className="mb-2 mb-lg-0">
                  <Row>
                    <Col xl={8} lg={8} className="mb-2 mb-lg-0">
                      <InputText
                        labelName={_.get(
                          elements,
                          "branchCreationElement.galleryHastagLabelElement",
                          "Hastags"
                        )}
                        inputType={"text"}
                        inputName={"hashtagText"}
                        customValue={state.hashtagText}
                        tooltip={""}
                        inputPlaceholder={_.get(
                          elements,
                          "branchCreationElement.galleryHastagPlaceholderElement",
                          "Enter Hastags"
                        )}
                        customOnChange={(e) => handleChangeHashtag(e)}
                      />
                    </Col>
                    <Col xl={4} lg={4} className="mb-2 mb-lg-0 ">
                      <div className="d-flex align-items-center h-100 mt-1 pt-1">
                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "branchCreationElement.galleryAddElement",
                            "Add"
                          )}
                          customClass={
                            "btn-outline-dark bg-none ml-2 btnthemeColor"
                          }
                          customClick={handleAddHashTag}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xl={12}>
                      <div className="d-flex flex-wrap hastag-wrapper">
                        {state.hashtags.map((item, index) => (
                          <span className="mr-2 border p-2 rounded position-relative d-flex mb-2">
                            <Icon
                              className="editIcon mr-2"
                              onClick={(e) => handleRemoveHasTag(e, index)}
                              icon={close}
                            />
                            <span>{item}</span>
                          </span>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Col>
                <Col xl={6} sm={12} className="mb-2 mb-lg-0">
                  <InputText
                    labelName={_.get(
                      elements,
                      "branchCreationElement.descriptionLabelElement",
                      "Description"
                    )}
                    inputType={"textarea"}
                    inputName={"description"}
                    customValue={state.description}
                    tooltip={""}
                    inputPlaceholder={_.get(
                      elements,
                      "branchCreationElement.descriptionGalleryPlaceholderElement",
                      "Enter Description"
                    )}
                    customOnChange={(e) => handleNameChange(e)}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                <CustomButton
                  customType={"submit"}
                  name={_.get(
                    elements,
                    "branchCreationElement.submitButtonElement",
                    "Submit"
                  )}
                  customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                  customClick={handleSubmitForm}
                />
              </div>
            </ModalFooter>
          </Modal>
        </Form>
        {props.singleRide !== null ? (
          <Card>
            <CardBody>
              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideNameElement",
                      "Ride Name"
                    )}
                    titleName={props.singleRide.rideName}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.startPointElement",
                      "Start Point"
                    )}
                    titleName={props.singleRide.startPoint.name}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.sourceLatElement",
                      "Source Latitude"
                    )}
                    titleName={props.singleRide.startPoint.latitude}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.sourceLongElement",
                      "Source Longitude"
                    )}
                    titleName={props.singleRide.startPoint.longitude}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.destinationElement",
                      "Destination"
                    )}
                    titleName={props.singleRide.endPoint.name}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.destinationLatElement",
                      "Destination Latitude"
                    )}
                    titleName={props.singleRide.endPoint.latitude}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.destinationLongElement",
                      "Destination Longitude"
                    )}
                    titleName={props.singleRide.endPoint.longitude}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideStatusElement",
                      "Ride Status"
                    )}
                    titleName={helperFunctionForStatus(
                      props.singleRide.rideStatus,
                      elements
                    )}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideStartDateElement",
                      "Ride Start Date"
                    )}
                    titleName={helperFunctionForDate(
                      props.singleRide.rideInfo.rideStartDateIso
                    )}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.RideEndDateElement",
                      "Ride End Date"
                    )}
                    titleName={helperFunctionForDate(
                      props.singleRide.rideInfo.rideEndDateIso
                    )}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.distFromTOElement",
                      "Distance From to To"
                    )}
                    titleName={props.singleRide.rideInfo.totalDistance}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideLevelElement",
                      "Ride Duration"
                    )}
                    titleName={props.singleRide.rideInfo.rideLevel}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.assemblingTimeElement",
                      "Assembling Time"
                    )}
                    titleName={helperFunctionForTime(
                      props.singleRide.rideInfo.assemblingTime
                    )}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.countryElement",
                      "Country"
                    )}
                    titleName={props.singleRide.rideInfo.country}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.stateElement",
                      "State"
                    )}
                    titleName={props.singleRide.rideInfo.state}
                  />
                </Col>
                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.cityElement",
                      "City"
                    )}
                    titleName={props.singleRide.rideInfo.city}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.lastDateOfRegistrationElement",
                      "Last Date of Registration"
                    )}
                    titleName={helperFunctionForDate(
                      props.singleRide.registrationCutOffDate
                    )}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.moderationStatusElement",
                      "Moderation Status"
                    )}
                    titleName={helperFunctionForStatus(
                      props.singleRide.moderationStatus,
                      elements
                    )}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideCoordinatorNameElement",
                      "Coordinator Name"
                    )}
                    titleName={props.singleRide.rideChampion}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideCoordinatorMobileElement",
                      "Coordinator Mobile"
                    )}
                    titleName={props.singleRide.rideChampionMobile}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideRegistrationFeeElement",
                      "Registration Fee"
                    )}
                    titleName={props.singleRide.registrationFee}
                  />
                </Col>

                <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.rideDurationElement",
                      "Ride Duration In Hours"
                    )}
                    titleName={props.singleRide.rideInfo.durationInDays}
                  />
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} className="mb-4">
                  <DesignCard
                    name={_.get(
                      elements,
                      "rideDetailElement.descriptionElement",
                      "Description"
                    )}
                    titleName={props.singleRide.rideInfo.rideDetails}
                  />
                </Col>
              </Row>
              {props.page === "list" ? (
                <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "rideDetailElement.backButtonElement",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => handleGoBack()}
                  />

                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "rideDetailElement.imageButtonElement",
                      "Add Image"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                    customClick={() => toggle()}
                  />

                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "rideDetailElement.updateButtonElement",
                      "Update"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                    customClick={() => handleToUpdate()}
                  />
                </div>
              ) : (
                <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "rideDetailElement.backButtonElement",
                      "Back"
                    )}
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => handleGoBackFromModeration()}
                  />

                  {props.singleRide.rideStatus === "COMPLETED" &&
                  props.displayName !== "Admin" ? (
                    <CustomButton
                      customType={"submit"}
                      name={_.get(
                        elements,
                        "rideDetailElement.imageButtonElement",
                        "Add Image"
                      )}
                      customClass={
                        "btn-outline-dark bg-none ml-2 btnthemeColor"
                      }
                      customClick={() => toggle()}
                    />
                  ) : null}

                  <CustomButton
                    customType={"submit"}
                    name={_.get(
                      elements,
                      "rideDetailElement.updateButtonElement",
                      "Update"
                    )}
                    customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
                    customClick={() => handleRideUpdate()}
                  />
                  {props.singleRide.moderationStatus === "PENDING" ? (
                    <React.Fragment>
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "rideDetailElement.approveButtonElement",
                          "Approve"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={(e) => handleStatusSubmit(e, "APPROVED")}
                      />
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "rideDetailElement.disApproveButtonElement",
                          "Reject"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={(e) => handleStatusSubmit(e, "REJECTED")}
                      />
                    </React.Fragment>
                  ) : null}

                  {props.singleRide.moderationStatus === "APPROVED" ? (
                    <React.Fragment>
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "rideDetailElement.disApproveElement",
                          "Reject"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={(e) => handleStatusSubmit(e, "REJECTED")}
                      />
                    </React.Fragment>
                  ) : null}

                  {props.singleRide.moderationStatus === "REJECTED" ? (
                    <React.Fragment>
                      <CustomButton
                        customType={"submit"}
                        name={_.get(
                          elements,
                          "rideDetailElement.approveButtonElement",
                          "Approve"
                        )}
                        customClass={
                          "btn-outline-dark bg-none ml-2 btnthemeColor"
                        }
                        customClick={(e) => handleStatusSubmit(e, "APPROVED")}
                      />
                    </React.Fragment>
                  ) : null}
                </div>
              )}
            </CardBody>
          </Card>
        ) : null}
        <Modal isOpen={state.toggleRejectModal}>
          <ModalHeader toggle={handleToggleRejectModal}>
            {_.get(
              elements,
              "rideDetailElement.rejectionReasonElement",
              "Rejection Reason"
            )}
          </ModalHeader>
          <ModalBody>
            <InputText
              inputType={"textarea"}
              inputName={"rejectionReason"}
              customValue={state.rejectionReason}
              customOnChange={(e) => handleNameChange(e)}
            />
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "rideDetailElement.rejectButtonElement",
                "Reject"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => handleSubmitRejection(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default rideDetail;
